import { texts } from '../../../../../constants/texts';
import PhoneField from '../../../../common/formComponents/PhoneField/PhoneField';
import TextField from '../../../../common/formComponents/TextField/TextField';
import { getInputOptions } from '../../utils/getInputOptions';
import CheckboxField from '../../../../common/formComponents/CheckboxField/CheckboxField';
import { phoneMask } from '../../../../../utils/phoneMask';
import OpenChangeData from '../components/OpenChangeData/OpenChangeData';
import {
  getBaseNameFields,
  getFioField,
  getVerifiedField,
} from '../utils/utils';

const useGetAddTenantFieldsData = () => {
  const getAddTenantFieldsData = ({
    tenantData,
    onPhoneChange,
    onChangeVisible,
    isEdit = false,
    visible,
    isShowVerified = false,
  }) => [
    ...(isEdit
      ? [
          getFioField({ tenantData }),
          ...getBaseNameFields({ tenantData }),
          ...(isShowVerified ? [...getVerifiedField({ tenantData })] : []),
        ]
      : [
          ...(!!tenantData
            ? [
                getFioField({ tenantData }),
                {
                  name: 'change-data',
                  span: 24,
                  element: OpenChangeData,
                  onChange: onChangeVisible,
                },
                ...(visible
                  ? getBaseNameFields({ tenantData, isRequired: false })
                  : []),
              ]
            : getBaseNameFields({ tenantData })),
        ]),
    {
      label: 'Телефон',
      name: 'phone',
      options: getInputOptions({
        requiredErrMsg: 'Укажите телефон',
        validationTypes: !tenantData?.phone ? ['phoneLength'] : [],
        initialValue: tenantData?.phone
          ? phoneMask(tenantData.phone)
          : undefined,
      }),
      inputProps: {
        disabled: Boolean(tenantData?.phone),
        onChange: onPhoneChange,
      },
      span: 9,
      element: PhoneField,
    },
    {
      label: 'Email',
      name: 'email',
      options: getInputOptions({
        validationTypes: ['email'],
        initialValue: tenantData?.email,
      }),
      span: 15,
      element: TextField,
    },
    {
      label: '',
      name: 'isOwner',
      text: texts.owner,
      options: getInputOptions({
        initialValue: tenantData?.isOwner ?? true,
      }),
      span: 24,
      element: CheckboxField,
    },
    {
      label: '',
      name: 'id',
      options: getInputOptions({
        initialValue: tenantData?.id,
      }),
      inputProps: {
        hidden: true,
      },
      span: 0,
      element: TextField,
    },
  ];

  return getAddTenantFieldsData;
};

export default useGetAddTenantFieldsData;
